// @generated by protoc-gen-connect-es v1.4.0 with parameter "target=ts,import_extension=none"
// @generated from file daemon/v1alpha/daemon.proto (package com.seed.daemon.v1alpha, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { AddDomainRequest, AuthenticateRequest, AuthenticateResponse, CheckDomainRequest, CreateDeviceLinkSessionRequest, DeleteAllKeysRequest, DeleteKeyRequest, DeviceLinkSession, DisconnectVaultRequest, DomainInfo, ExportKeyRequest, ForceReindexRequest, ForceReindexResponse, ForceSyncRequest, GenMnemonicRequest, GenMnemonicResponse, GetDeviceLinkSessionRequest, GetDomainRequest, GetInfoRequest, GetVaultStatusRequest, GetVaultStatusResponse, ImportKeyRequest, Info, ListDomainsRequest, ListDomainsResponse, ListKeysRequest, ListKeysResponse, NamedKey, RegisterKeyRequest, RemoveDomainRequest, SignDataRequest, SignDataResponse, StartVaultConnectionRequest, StartVaultConnectionResponse, StoreBlobsRequest, StoreBlobsResponse, UpdateKeyRequest } from "./daemon_pb";
import { Empty, MethodKind } from "@bufbuild/protobuf";

/**
 * Daemon API allows to control and administer the Seed Daemon.
 *
 * @generated from service com.seed.daemon.v1alpha.Daemon
 */
export const Daemon = {
  typeName: "com.seed.daemon.v1alpha.Daemon",
  methods: {
    /**
     * Generates a set of BIP-39-compatible mnemonic words encoding a cryptographic seed.
     * This is a stateless call, and the generated mnemonic is not stored anywhere.
     * Subsequent call to RegisterKey can be used to register a new signing key derived from the mnemonic.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.GenMnemonic
     */
    genMnemonic: {
      name: "GenMnemonic",
      I: GenMnemonicRequest,
      O: GenMnemonicResponse,
      kind: MethodKind.Unary,
    },
    /**
     * After generating the seed, this call is used to commit the seed and
     * create an account binding between the device and account.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.RegisterKey
     */
    registerKey: {
      name: "RegisterKey",
      I: RegisterKeyRequest,
      O: NamedKey,
      kind: MethodKind.Unary,
    },
    /**
     * Imports an existing signing key from a .hmkey.json file on disk.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.ImportKey
     */
    importKey: {
      name: "ImportKey",
      I: ImportKeyRequest,
      O: NamedKey,
      kind: MethodKind.Unary,
    },
    /**
     * Exports an existing signing key to a .hmkey.json file on disk.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.ExportKey
     */
    exportKey: {
      name: "ExportKey",
      I: ExportKeyRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * Get generic information about the running node.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.GetInfo
     */
    getInfo: {
      name: "GetInfo",
      I: GetInfoRequest,
      O: Info,
      kind: MethodKind.Unary,
    },
    /**
     * Authenticates a caller key and returns a daemon bearer token.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.Authenticate
     */
    authenticate: {
      name: "Authenticate",
      I: AuthenticateRequest,
      O: AuthenticateResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets the current local-vault backend and sync status.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.GetVaultStatus
     */
    getVaultStatus: {
      name: "GetVaultStatus",
      I: GetVaultStatusRequest,
      O: GetVaultStatusResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Starts a browser-mediated remote vault connection flow.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.StartVaultConnection
     */
    startVaultConnection: {
      name: "StartVaultConnection",
      I: StartVaultConnectionRequest,
      O: StartVaultConnectionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Disconnects the daemon from remote vault sync and falls back to local-only mode.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.DisconnectVault
     */
    disconnectVault: {
      name: "DisconnectVault",
      I: DisconnectVaultRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * Force-trigger periodic background sync of Seed objects.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.ForceSync
     */
    forceSync: {
      name: "ForceSync",
      I: ForceSyncRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * Forces the daemon to reindex the entire database.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.ForceReindex
     */
    forceReindex: {
      name: "ForceReindex",
      I: ForceReindexRequest,
      O: ForceReindexResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Lists all the signing keys registered on this Daemon.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.ListKeys
     */
    listKeys: {
      name: "ListKeys",
      I: ListKeysRequest,
      O: ListKeysResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Updates the existing key.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.UpdateKey
     */
    updateKey: {
      name: "UpdateKey",
      I: UpdateKeyRequest,
      O: NamedKey,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes a key from the underlying key store.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.DeleteKey
     */
    deleteKey: {
      name: "DeleteKey",
      I: DeleteKeyRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * Deletes all Seed keys from the underlying key store.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.DeleteAllKeys
     */
    deleteAllKeys: {
      name: "DeleteAllKeys",
      I: DeleteAllKeysRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * Receives raw blobs to be stored.
     * The request may fail if blobs can't be recognized by the daemon.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.StoreBlobs
     */
    storeBlobs: {
      name: "StoreBlobs",
      I: StoreBlobsRequest,
      O: StoreBlobsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Creates a new device link session.
     * The session information has to be transferred to the other device,
     * to establish a direct P2P connection between the devices, and complete the linking process.
     *
     * There can only be one active session at a time, and creating a new one will invalidate the previous one.
     *
     * After the session is redeemed, it becomes invalid.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.CreateDeviceLinkSession
     */
    createDeviceLinkSession: {
      name: "CreateDeviceLinkSession",
      I: CreateDeviceLinkSessionRequest,
      O: DeviceLinkSession,
      kind: MethodKind.Unary,
    },
    /**
     * Get the current device link session (if it exists).
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.GetDeviceLinkSession
     */
    getDeviceLinkSession: {
      name: "GetDeviceLinkSession",
      I: GetDeviceLinkSessionRequest,
      O: DeviceLinkSession,
      kind: MethodKind.Unary,
    },
    /**
     * Sign arbitrary data with an existing signing key.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.SignData
     */
    signData: {
      name: "SignData",
      I: SignDataRequest,
      O: SignDataResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Gets cached information about a domain.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.GetDomain
     */
    getDomain: {
      name: "GetDomain",
      I: GetDomainRequest,
      O: DomainInfo,
      kind: MethodKind.Unary,
    },
    /**
     * Lists all tracked domains.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.ListDomains
     */
    listDomains: {
      name: "ListDomains",
      I: ListDomainsRequest,
      O: ListDomainsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Adds a domain to be tracked.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.AddDomain
     */
    addDomain: {
      name: "AddDomain",
      I: AddDomainRequest,
      O: DomainInfo,
      kind: MethodKind.Unary,
    },
    /**
     * Removes a tracked domain.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.RemoveDomain
     */
    removeDomain: {
      name: "RemoveDomain",
      I: RemoveDomainRequest,
      O: Empty,
      kind: MethodKind.Unary,
    },
    /**
     * Forces a re-check of a domain's /hm/api/config endpoint.
     *
     * @generated from rpc com.seed.daemon.v1alpha.Daemon.CheckDomain
     */
    checkDomain: {
      name: "CheckDomain",
      I: CheckDomainRequest,
      O: DomainInfo,
      kind: MethodKind.Unary,
    },
  }
} as const;

